// Lazy Swiper initialization using IntersectionObserver
// Only initializes Swiper when the carousel enters viewport

const swiperObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const el = entry.target;
      if (!el.dataset.swiperInitialized) {
        el.dataset.swiperInitialized = 'true';
        import('./slideshow-section.js').then(module => {
          module.initSwiper(el);
        });
      }
      swiperObserver.unobserve(el);
    }
  });
}, { rootMargin: '200px' });

document.querySelectorAll('[data-lazy-swiper]').forEach(el => swiperObserver.observe(el));